module.exports = "<i *ngIf=\"visible\" class=\"fa fa-spinner fa-spin fa-2x\"></i>"